import styled from 'styled-components';
import { media } from 'components/styled/utils';

const Card = styled.div`
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.19);
  border-radius: 4px;
  /* padding: 18px 16px; */

  ${media.sm`
      /* padding: 28px 42px; */
  `};
`;

Card.displayName = 'Card';

export default Card;



// WEBPACK FOOTER //
// ./src/components/styled/ui/card/card.js